import { render, staticRenderFns } from "./VendorManagment.vue?vue&type=template&id=2bd34310&scoped=true"
import script from "./VendorManagment.vue?vue&type=script&lang=js"
export * from "./VendorManagment.vue?vue&type=script&lang=js"
import style0 from "./VendorManagment.vue?vue&type=style&index=0&id=2bd34310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd34310",
  null
  
)

export default component.exports